export default class SeatSelectorApi {
  constructor (token) {
    this.token = token
    return this
  }

  getPassengers () {
    return new Promise((resolve, reject) => {
      window.axios.get(`${process.env.API_URL}api/v1/ancillaries/${this.token}/passengers`)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error.response.data))
    })
  }

  updatePassenger (id, idType, passenger) {
    return new Promise((resolve, reject) => {
      let passengerRequest = passenger
      if (idType === 'external_id') {
        passengerRequest.external_id = id
      } else {
        passengerRequest.id = id
      }

      window.axios.post(`${process.env.API_URL}api/v1/ancillaries/${this.token}/passengers`, {
        passengers: [passengerRequest]
      }).then((response) => {
        window.EventBus.dispatchEvent('ss-seat-selection-update-passenger', response.data.data.passengers[0])
        resolve(response.data)
      }).catch((error) => reject(error.response.data))
    })
  }

  updatePassengers (passengers) {
    return new Promise((resolve, reject) => {
      window.axios.post(`${process.env.API_URL}api/v1/ancillaries/${this.token}/passengers`, {
        passengers: passengers
      }).then((response) => {
        let passengers = response.data.data.passengers
        for (var i = 0; i < passengers.length; i++) {
          window.EventBus.dispatchEvent('ss-seat-selection-update-passenger', passengers[i])
        }
        resolve(response.data)
      }).catch((error) => reject(error.response.data))
    })
  }

  updateSeatSelection (id, idType, params) {
    return new Promise((resolve, reject) => {
      let passengerSeatRequest = params
      if (idType === 'external_id') {
        passengerSeatRequest.external_id = id
      } else {
        passengerSeatRequest.id = id
      }

      window.axios.post(`${process.env.API_URL}api/v1/ancillaries/${this.token}/save-seat`, passengerSeatRequest).then((response) => {
        window.EventBus.dispatchEvent('ss-seat-selection-update-passenger-seat', response.data)
        resolve(response.data)
      }).catch((error) => reject(error.response.data))
    })
  }

  clearSeats () {
    return new Promise((resolve, reject) => {
      window.axios.get(`${process.env.API_URL}api/v1/ancillaries/clear-seats?token=${this.token}`)
        .then((response) => resolve([]))
        .catch((error) => reject(error))
    })
  }
}



// WEBPACK FOOTER //
// ./src/SeatSelectorApi.js